export default __webpack_public_path__ + "static/media/SAP - Logo2.c42eef75.png";